import { authenticatedAxios } from '../backend.service'
import { convertirPeriodo } from '../../common/utils/functions/periodo'
import { swapPeriodo } from '../../common/components/InputMonthYear/date.utils'
//1541
const version = 'v2'
const paths = {
  create: `${version}/declaraciones/nomina`,
  getById: (id) => `${version}/declaraciones/nomina/${id}`,
  getPlantillaBase: `${version}/declaraciones/nomina/descarga`,
  getNominaConErrores: (id) => `${version}/declaraciones/nomina/${id}/descarga`,
  getResumenNomina: (id) => `${version}/declaraciones/nomina/resumen/${id}`,
  validateNomina: `${version}/declaraciones/nomina/detalle`,
  updateDetalleNomina: `${version}/declaraciones/nomina`,
}

export const createDeclaracionNomina = async ({ periodo, file }) => {
  periodo = convertirPeriodo(swapPeriodo(periodo))
  const formData = new FormData()

  formData.append('nomina', file)
  formData.append('periodo', periodo)

  const response = await authenticatedAxios.post(paths.create, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  if (response.status === 200 || response.status == 400) {
    return response
  }
  return false
}

export const getDetalleNomina = async ({ id, query }) => {
  const response = await authenticatedAxios.get(`${paths.getById(id)}${query}`)
  if (response.status === 200) {
    return response
  }
  return false
}

export const getPlantilaBase = async () => {
  const response = await authenticatedAxios.get(paths.getPlantillaBase, { responseType: 'blob' })
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const contentDisposition = response.headers['content-disposition']
  let fileName = 'archivo.xlsx'
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/)
    if (match && match[1]) {
      fileName = match[1]
    }
  }

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  link.click()
}

export const getNominaConErrores = async (id) => {
  const response = await authenticatedAxios.get(paths.getNominaConErrores(id), { responseType: 'blob' })
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const contentDisposition = response.headers['content-disposition']
  let fileName = 'archivo.xlsx'
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/)
    if (match && match[1]) {
      fileName = match[1]
    }
  }

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  link.click()
}

export const getResumenNomina = async (id) => {
  const response = await authenticatedAxios.get(paths.getResumenNomina(id))

  if (response.status === 200) {
    return response
  }
  return false
}

export const validateNomina = async ({ id }) => {
  try {
    const response = await authenticatedAxios.post(paths.validateNomina, {
      id,
    })
    return response
  } catch (error) {
    return error
  }
}

export const updateDeclaracionNomina = async ({ idNomina, file }) => {
  const formData = new FormData()

  formData.append('nomina', file)
  formData.append('id', idNomina)

  const response = await authenticatedAxios.put(paths.updateDetalleNomina, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  if (response.status === 200 || response.status == 400) {
    return response
  }
  return false
}
